import CustomSelect from 'components/ui/Editor/CustomSelect';
import FormikValidationError from 'components/ui/FormikErrors';
import TextInput from 'components/ui/TextInput';
import { FormikProps } from 'formik';
import { FC } from 'react';
import { IInternalUserInput } from './schema';
import { useDecodeToken } from 'hooks/useStorage';

interface IInternalUserForm {
  formik: FormikProps<IInternalUserInput>;
}

const InternalUserForm: FC<IInternalUserForm> = ({ formik }) => {
  const decodedToken: any = useDecodeToken();

  const isSuperAdmin = decodedToken?.IsSuperUser == 'True';

  const roleList = isSuperAdmin ? [
    { value: 'INTERNAL', label: 'Internal' },
    { value: 'EXTERNAL', label: 'External' }
  ] : [
    { value: 'EXTERNAL', label: 'External' }

  ]

  return (
    <form>
      <div className="row">
        <div className="col-12 col-md-6 col-lg-4 mt-2">
          <TextInput
            label="First Name"
            name="first_name"
            type="text"
            onChange={formik.handleChange}
            value={formik.values.first_name}
            onBlur={formik.handleBlur}
            formik={formik}
            required
            containerClassName="col-12"
          />

          <TextInput
            label="Email"
            name="email"
            type="text"
            onChange={formik.handleChange}
            value={formik.values.email}
            onBlur={formik.handleBlur}
            formik={formik}
            required
            containerClassName="col-12"
          />

        </div>

        <div className="col-12 col-md-6 col-lg-4 mt-2">
          <TextInput
            label="Middle Name"
            name="middle_name"
            type="text"
            onChange={formik.handleChange}
            value={formik.values.middle_name}
            onBlur={formik.handleBlur}
            formik={formik}
            containerClassName="col-12"
          />
          <TextInput
            label="Mobile Number"
            name="mobile_number"
            type="number"
            onChange={formik.handleChange}
            value={formik.values.mobile_number}
            onBlur={formik.handleBlur}
            formik={formik}
            required
            containerClassName="col-12"
          />




        </div>
        <div className="col-12 col-md-6 col-lg-4 mt-2">

          <TextInput
            label="Last Name"
            name="last_name"
            type="text"
            onChange={formik.handleChange}
            value={formik.values.last_name}
            onBlur={formik.handleBlur}
            formik={formik}
            required
            containerClassName="col-12"
          />



          <CustomSelect
            name="role"
            options={roleList}
            placeholder={'Search user type '}
            value={formik.values.role}
            onChange={(value: any) => formik.setFieldValue('role', value)}
            label={'Select  User type'}
            required
            containerClassName="col-12"
          />
          <FormikValidationError name="role" errors={formik.errors} touched={formik.touched} />
        </div>
      </div>

      {formik.values.role === 'EXTERNAL' ? <div className="row mt-3">
        <div className="col-12 col-md-6 col-lg-4 mt-2">
          <TextInput
            label="Bank Name"
            name="bank_name"
            type="text"
            onChange={formik.handleChange}
            value={formik.values.bank_name}
            onBlur={formik.handleBlur}
            formik={formik}
            containerClassName="col-12"
          />
        </div>

        <div className="col-12 col-md-6 col-lg-4 mt-2">
          <TextInput
            label="Account Holder Name"
            name="bank_account_holder"
            type="text"
            onChange={formik.handleChange}
            value={formik.values.bank_account_holder}
            onBlur={formik.handleBlur}
            formik={formik}
            containerClassName="col-12"
          />
        </div>

        <div className="col-12 col-md-6 col-lg-4 mt-2">
          <TextInput
            label="Account Number"
            name="bank_account_number"
            type="text"
            onChange={formik.handleChange}
            value={formik.values.bank_account_number}
            onBlur={formik.handleBlur}
            formik={formik}
            containerClassName="col-12"
          />
        </div>
      </div> : ''}

      {formik.values.role === 'EXTERNAL' ? <div className="row mt-3">
        <div className="col-12 col-md-6 col-lg-4 mt-2">
          <TextInput
            label="Bank Branch"
            name="bank_branch"
            type="text"
            onChange={formik.handleChange}
            value={formik.values.bank_branch}
            onBlur={formik.handleBlur}
            formik={formik}
            containerClassName="col-12"
          />
        </div>

        <div className="col-12 col-md-6 col-lg-8 mt-2">
          <TextInput
            label="Pan Number"
            name="pan_number"
            type="number"
            onChange={formik.handleChange}
            value={formik.values.pan_number}
            onBlur={formik.handleBlur}
            formik={formik}
            containerClassName="col-12"
          />
          {/* <TextInput
            label="Bank Address"
            name="bank_address"
            type="text"
            onChange={formik.handleChange}
            value={formik.values.bank_address}
            onBlur={formik.handleBlur}
            formik={formik}
            required
            containerClassName="col-12"
          /> */}
        </div>
      </div> : ''}
    </form>
  );
};

export default InternalUserForm;
